// export const API_URL = 'https://kiq-idoh-nora-dev-api.azurewebsites.net';
export const API_URL = 'https://kiq-idoh-nora-test-v1.azurewebsites.net';

export const API_KEY = 'Tk9SQV9BZG1pbjpmNWFnQlhGSmNhS3h1Mzdk';

export const UI = {
	main: 'hsl(260, 75%, 32%)',
	mainTranslucent: 'hsla(260, 75%, 32%, 50%)',
	progmentum: 'hsl(207, 58%, 54%)',
	gradient1: 'hsl(260, 75%, 36%)',
	gradient2: 'hsl(260, 75%, 24%)',
	gradient3: 'hsl(260, 75%, 12%)'
};
